(function ($) {
	var ajaxCall = {
		readyState: 4,
	};

	var crossCheckedClass = "cross-product--checked";

	function pulseCheckboxes($scope) {
		($scope || $(document)).find(".checkbox").each(function (i, el) {
			$(el).removeClass("green-pulse-animation");
			$(el)[0].offsetHeight;
			$(el).addClass("green-pulse-animation");
		});
	}

	function toggleCrossProduct($tile) {
		if (ajaxCall.readyState != 4) {
			return;
		}
		if (!$tile || $tile.length === 0) {
			return;
		}

		var $parent = $tile.parents(".product-wrapper");
		var productId = $tile.data("productId");

		// only one checked per wrapper
		$.each($parent.find(".cross-product"), function () {
			if (productId != $(this).data("productId") && $(this).hasClass(crossCheckedClass)) {
				$(this).removeClass(crossCheckedClass);
				ajaxCall = mobileCart.removeProductCrossSell($(this));
			}
		});

		if ($tile.hasClass(crossCheckedClass)) {
			$tile.removeClass(crossCheckedClass);
			if (mobileCart.shouldAddCategorizedIcsWithProduct() === false) {
				ajaxCall = mobileCart.removeProductCrossSell($tile);
			}
		} else {
			$tile.addClass(crossCheckedClass);
			if (mobileCart.shouldAddCategorizedIcsWithProduct() === false) {
				ajaxCall = mobileCart.addProductCrossSell($tile);
			}
		}

		pulseCheckboxes($(".categorized-cross-sell"));
	}

	$(".cross-product").on("click", function (e) {
		// Return early if clicked target is kasko-insurance-more
		if ($(e.target).hasClass("kasko-insurance-more") || $(e.target).hasClass("kasko-meta-keywords-link")) {
			return;
		}

		var $parent = $(this).parents(".product-wrapper");
		// For Kasko: tiles should not be clickable (header controls it).
		if ($parent.hasClass("kasko-product-wrapper")) {
			return;
		}

		toggleCrossProduct($(this));
	});

	// Kasko: allow toggling via header click (same behavior as clicking first tile).
	$(".cross-header").on("click", function (e) {
		// Don't hijack clicks on links inside header (if any).
		if ($(e.target).closest("a").length) {
			return;
		}

		var $parent = $(this).parents(".product-wrapper");
		if (!$parent.hasClass("kasko-product-wrapper")) {
			return;
		}

		var $header = $(this);
		var headerCheckedClass = "cross-header--checked";
		var $first = $parent.find(".cross-product").first();
		if (!$first.length) {
			return;
		}

		// Toggle header checked state, keep tile/cart in sync.
		var shouldBeChecked = !$header.hasClass(headerCheckedClass);
		if (shouldBeChecked) {
			$header.addClass(headerCheckedClass);
			if (!$first.hasClass(crossCheckedClass)) {
				toggleCrossProduct($first);
			}
		} else {
			$header.removeClass(headerCheckedClass);
			if ($first.hasClass(crossCheckedClass)) {
				toggleCrossProduct($first);
			}
		}
	});
})(jQuery);

(function ($) {
	"use strict";

	var timer = 90;
	var timeElapsed = timer;
	var interval;
	var icsPopup;
	var ajaxCall;

	window.icsPopup = function() {
		this.defaults = {
			selector: "#ics-popup-cross",
		};

		if (arguments[0] && typeof arguments[0] === "object") {
			this.defaults = extendDefaults(this.defaults, arguments[0]);
		}

		icsPopup = $(this.defaults.selector).eq(0);

		icsPopup.find(".close-popup").on("click", function () {
			icsPopup.fadeOut(function () {
				closeOffer();
			});
		});
	
		icsPopup.find(".add-ics-popup").on("click", function () {
			$(this).addClass("loading-overlay");
			var _self = this;
			ajaxCall = mobileCart.addProductCrossSell($(this), function() {
				$(_self).removeClass("loading-overlay");
				closeOffer();
			});
		});

		icsPopup.find(".no-thanks span").on("click", closeOffer);
	};

	// Utility method to extend defaults with user options
	function extendDefaults(source, properties) {
		var property;
		for (property in properties) {
			if (properties.hasOwnProperty(property)) {
				source[property] = properties[property];
			}
		}
		return source;
	}

	function runCountdown() {
		interval = setInterval(function () {
			icsPopup.find(".expires-in").text(icsPopup.find(".expires-in").data("text").replace("%seconds%", timeElapsed));
			icsPopup.find(".progress-bar .bar").css("width", (timeElapsed / timer) * 100 + "%");
	
			timeElapsed--;
	
			if (timeElapsed <= 0) {
				clearInterval(interval);
				offerExpired();
			}
		}, 1000);
	}

	function offerExpired() {
		icsPopup.find(".progress-bar .bar").css("width", "0%");
		closeOffer();
	}

	function closeOffer() {
		clearInterval(interval);
		icsPopup.remove();
		window._icsPopup = "";
		$("#goToCheckout").click();
	}

	window.icsPopup.prototype.init = function(clickEvent) {
		if(icsPopup.length == 0) {
			closeOffer();
			return false;
		}

		var productIds = [];
		mobileCart.getProductsInShoppingCart().forEach(function(el) {
			productIds.push(el.productId);
		});
		
		if(productIds.indexOf(parseInt(icsPopup.find(".add-ics-popup").data("productId"))) !== -1) {
			closeOffer();
			return false;
		}

		clickEvent.preventDefault();
		runCountdown();
		icsPopup.fadeIn();

		var confetti = new wave__confetti({ duration: 3000 });
		confetti.run();

		var obj = {
			event_category: $('body').data('productId'),
			event_action: "impression_reborn_popup",
			event_label: icsPopup.find(".add-ics-popup").data("productId")
		};
		gatgEvent(obj);
	};
})(jQuery);

if(["si", "hr", "hu", "cz"].indexOf(window.jstransobj.locale) !== -1) {
	var _icsPopup = new icsPopup();
}